import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from 'app/components/common/checkbox';
import Input from 'app/tyler/components/rgb/input';
import helpers from 'app/tyler/helpers/rgb';

class RgbChannel extends React.PureComponent {

  constructor(props) {
    super(props);

    // this.onChangeBit = this.onChangeBit.bind(this);
    this.onChangeSlider = this.onChangeSlider.bind(this);
  }

  get bin() {
    return helpers.decToBin(this.props.value);
  }

  get hex() {
    return helpers.decToHex(this.props.value);
  }

  get title() {
    const chars = this.props.color.split('');
    chars[0] = chars[0].toUpperCase();
    return chars.join('');
  }

  // onChangeBit(i, event) {
  //   const on = event.target.checked;
  //   const newBin = [...this.bin];
  //   newBin.splice(i, 1, on);
  //   const newDec = helpers.binToDec(newBin);
  //   console.log({i, on, newBin, newDec});
  //   this.props.onChange(newDec);
  // }

  onChangeBit2(i, on) {
    const newBin = [...this.bin];
    newBin.splice(i, 1, on);
    const newDec = helpers.binToDec(newBin);
    console.log({i, on, newBin, newDec});
    this.props.onChange(newDec);
  }

  onChangeSlider(event) {
    const dec = parseInt(event.target.value);
    this.props.onChange(dec);
  }

  // onChangeInput(value) {
  //   this.props.onChange()
  // }

  render() {
    return (
      <div className={`rgb-channel ${this.props.color}`}>
        <div className="rgb-channel-head">
          <div className="rgb-channel-head-title">{this.title}</div>
          dec: <Input className="rgb-channel-head-input" value={this.props.value} base={10} onChange={this.props.onChange} />
          hex: <Input className="rgb-channel-head-input" value={this.props.value} base={16} onChange={this.props.onChange} />
        </div>
        <input type="range" min="0" max="255" onChange={this.onChangeSlider} value={this.props.value} className="rgb-channel-slider" />
        <div className="rgb-channel-bits">
          {this.bin.map((bit, i) => {
            return (
              <div className={`rgb-channel-bit ${bit ? 'on' : 'off'}`} key={i}>
                <div className="rgb-channel-bit-light" onClick={this.onChangeBit2.bind(this, i, !bit)}>
                  <span>{bit ? '1' : '0'}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

}

RgbChannel.propTypes = {
  color: PropTypes.oneOf(['red', 'green', 'blue']),
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default RgbChannel;
